import { render, staticRenderFns } from "./SubmenuTree.vue?vue&type=template&id=22fa8946&scoped=true"
import script from "./SubmenuTree.vue?vue&type=script&lang=js"
export * from "./SubmenuTree.vue?vue&type=script&lang=js"
import style0 from "./SubmenuTree.vue?vue&type=style&index=0&id=22fa8946&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa8946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fa8946')) {
      api.createRecord('22fa8946', component.options)
    } else {
      api.reload('22fa8946', component.options)
    }
    module.hot.accept("./SubmenuTree.vue?vue&type=template&id=22fa8946&scoped=true", function () {
      api.rerender('22fa8946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubmenuTree.vue"
export default component.exports